import { Navigate } from 'react-router-dom';
import { JSX } from 'react';
import { useAuth } from '../context/AuthContext';

export default function AdminRoute({ children }: { children: JSX.Element }) {
  const { token, isAdmin } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  return isAdmin ? children : <Navigate to="/" replace />;
}